import type { SupportedLangs } from "@/i18n/types";

/** 言語選択 UI の並び順もこの配列に従う。 */
export const SUPPORTED_LANGS: readonly SupportedLangs[] = ["ja", "en"];

export const isSupportedLang = (value: string): value is SupportedLangs =>
  SUPPORTED_LANGS.some((lang) => lang === value);
